import * as THREE from "three";
import * as ZapparThree from "@zappar/zappar-threejs";
import { Pass } from "./faceEffectPass";
import * as Passes from "./passes";

export class FaceEffectComposer {
  public passes: Pass[];

  public constructor(
    private camera: ZapparThree.Camera,
    private renderer: THREE.WebGLRenderer,
    private tracker: ZapparThree.FaceTracker,
    private faceBufferGeometry: ZapparThree.FaceBufferGeometry,
  ) {
    this.passes = [];
    this.addPass(new Passes.CopyFacePass());
  }

  public addPass(pass: Pass) {
    pass.camera = this.camera;
    pass.faceBufferGeometry = this.faceBufferGeometry;
    pass.tracker = this.tracker;
    this.passes.push(pass);
  }

  public removePass(pass: Pass) {
    const index = this.passes.indexOf(pass);
    if (index !== -1) {
      this.passes.splice(index, 1);
    }
  }

  public dispose() {
    this.passes.forEach((pass) => {
      pass.dispose();
    });
  }

  public render() {
    if (this.passes.length === 0) return;

    for (let i = 0; i < this.passes.length; i += 1) {
      this.passes[i].renderToTarget = i < this.passes.length - 1;
      const previousTexture = i > 0 ? this.passes[i - 1].renderTarget!.texture : this.camera.backgroundTexture;
      this.passes[i].render(previousTexture, this.renderer);
    }
  }

  public get material() {
    return this.passes[this.passes.length - 1];
  }
}
